import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph9 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title7')}
          anchor={[0.5, 0]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Text
          text={t('gameRules_title7_content_1')}
          x={60}
          y={120}
          style={paragraphStyle}

        />
        <Text
          x={60}
          y={270}
          text={t('gameRules_title7_content_2')}
          style={paragraphStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
